import {Component, ElementRef, HostBinding, Input} from '@angular/core';
import {Highlightable, ListKeyManagerOption} from '@angular/cdk/a11y';

@Component({
  selector: 'table-lookup-dropdown-item',
  templateUrl: './table-lookup-dropdown-item.component.html',
  styleUrls: ['./table-lookup-dropdown-item.component.scss'],
})
export class TableLookupDropdownItemComponent implements Highlightable , ListKeyManagerOption {
  @Input() item: any;
  @Input() disabled: boolean = false;
  private _isActive = false;
  constructor(private element: ElementRef) {
  }

  setActiveStyles(): void {
  }

  setInactiveStyles(): void {
  }
}
